import { Component, Input, OnInit, inject } from "@angular/core";
import { BaseDataTablePageDirective } from "@app/view/shared/base-pages/base-data-table-page/base-data-table-page.directive";
import { SystemSearchMetaRestService } from "@app/services/hal/system-search-meta-rest.service";
import { Store as NgrxStore } from "@ngrx/store";
import { MatDialog } from "@angular/material/dialog";
import { UntypedFormBuilder } from "@angular/forms";
import { Router } from "@angular/router";
import { ServiceErrorHandlerService } from "@app/view/shared/service-error-handler.service";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { AutoBookHistoryStore } from "@app/services/store/auto-book-history-store";
import { AutoBookHistory } from "@app/models/rest/auto-book-history";
import { MatToolbar } from "@angular/material/toolbar";
import { MatButton } from "@angular/material/button";
import { GridComponent } from "../../../shared/base-pages/base-data-table-page/grid.component";
import { MatPaginator } from "@angular/material/paginator";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-cyclical-history-list",
  templateUrl: "./cyclical-history-list.component.html",
  styleUrls: ["./cyclical-history-list.component.scss"],
  imports: [MatToolbar, MatButton, GridComponent, MatPaginator, TranslatePipe]
})
export class CyclicalHistoryListComponent
  extends BaseDataTablePageDirective<AutoBookHistory>
  implements OnInit
{
  autoBookHistoryStore: AutoBookHistoryStore;
  protected store: NgrxStore<any>;
  protected dialog: MatDialog;
  protected formBuilder: UntypedFormBuilder;
  protected router = inject(Router);
  serverErrorHandler: ServiceErrorHandlerService;
  protected ngxUiLoaderService: NgxUiLoaderService;

  /*
*   externalJobRef: string;
  visitId: number;
  bookedDate: Date;
  appointmentStart: Date;
  appointmentEnd: Date;
  success: boolean;
  message: string;
  autoBookProfileId: number;
  priorityId: number;
  priorityDescription: string;*/
  @Input()
  public columns: object[] = [
    {
      field: "externalJobRef",
      text: "External Job Ref",
      flex: 1,
      editor: false
    },
    {
      field: "bookedDate",
      text: "Booked Date",
      format: "DD/MM/YYYY HH:mm",
      type: "date",
      flex: 1,
      editor: false
    },
    {
      field: "appointmentStart",
      text: "Appointment Start",
      format: "DD/MM/YYYY HH:mm",
      type: "date",
      flex: 1,
      editor: false
    },
    {
      field: "appointmentEnd",
      text: "Appointment End",
      format: "DD/MM/YYYY HH:mm",
      type: "date",
      flex: 1,
      editor: false
    },
    {
      field: "success",
      text: "Success?",
      type: "check",
      flex: 1,
      editor: false
    },
    {
      field: "message",
      text: "Message",
      flex: 1,
      editor: false
    }
  ];

  constructor() {
    const systemSearchMetaRestService = inject(SystemSearchMetaRestService);
    const autoBookHistoryStore = inject(AutoBookHistoryStore);
    const store = inject<NgrxStore<any>>(NgrxStore);
    const dialog = inject(MatDialog);
    const formBuilder = inject(UntypedFormBuilder);
    const serverErrorHandler = inject(ServiceErrorHandlerService);
    const ngxUiLoaderService = inject(NgxUiLoaderService);

    super(
      systemSearchMetaRestService,
      autoBookHistoryStore,
      store,
      dialog,
      "AutoBookHistory",
      formBuilder,
      serverErrorHandler,
      ngxUiLoaderService
    );

    this.autoBookHistoryStore = autoBookHistoryStore;
    this.store = store;
    this.dialog = dialog;
    this.formBuilder = formBuilder;
    this.serverErrorHandler = serverErrorHandler;
    this.ngxUiLoaderService = ngxUiLoaderService;
  }

  public get pristine() {
    return (
      !this.gridStore.changes ||
      (this.gridStore.changes.added.length === 0 &&
        this.gridStore.changes.removed.length === 0 &&
        this.gridStore.changes.modified.length === 0)
    );
  }

  ngOnInit() {
    super.ngOnInit();

    this.gridStore.autoCommit = false;
    this.gridStore.load({});
  }

  refresh() {
    this.gridStore.load({});
  }
}
